<template>
  <AgreementComponets></AgreementComponets>
</template>

<script>
import AgreementComponets from '@/components/Agreement'

export default {
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    // [eventTrack]
    this.nativePVset('CARWASH_KIYAKU')
  },
  components: {
    AgreementComponets
  }
}
</script>
